import { useEffect, useState } from "react";
import { viewConversationHomepg } from "../services/chatService";
import { viewHomePannelDta } from "../services/chatService";

export const useConversation = (refreshConv, page) => {
  const [loadingConv, setLoadingconv] = useState(true);
  // const [sendingmessage, setSendingMessage] = useState([]);
  // const [recivingMessage, setRecivingMessage] = useState([]);
  const [messages, setMessages] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState(null);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  console.log(page, "hoookss");
  useEffect(() => {
    const fetchConversation = async () => {
      try {
        setLoadingconv(true);

        await delay(500); // Add 500ms delay before fetching the conversation

        const response = await viewConversationHomepg(page);

        if (response.messages && response.messages.length > 0) {
          setMessages(response.messages || []);
          // setRecivingMessage(
          //   response.get_single_message[0].receiving_messages || []
          // );
          setPaginationInfo(response.pagination);
        } else {
          setMessages([]);
        }

        // if (
        //   response.get_single_message &&
        //   response.get_single_message.length > 0
        // ) {
        //   setSendingMessage(
        //     response.get_single_message[0].sending_messages || []
        //   );
        //   setRecivingMessage(
        //     response.get_single_message[0].receiving_messages || []
        //   );
        //   setPaginationInfo(response.page_context[0]);
        // } else {
        //   setSendingMessage([]);
        //   setRecivingMessage([]);
        // }
      } catch (error) {
        setMessages([]);
      } finally {
        setLoadingconv(false);
      }
    };

    fetchConversation();
  }, [refreshConv, page]);

  return { loadingConv, messages, paginationInfo };
};

export const useHomeChat = (refreshDependency = 0, skipLoader = false) => {
  const [channels, setChannels] = useState([]);
  const [directMessages, setDirectMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const fetchChatData = async () => {
      try {
        if (!skipLoader) {
          setLoading(true);
        }
        setError(null);
        await delay(500); // ⏳ Only add delay when loader is shown

        const response = await viewHomePannelDta();
        setChannels(response.data.userListInCompanySelect.channels || []);
        setDirectMessages(
          response.data.userListInCompanySelect.direct_chat_details || []
        );
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchChatData();
  }, [refreshDependency, skipLoader]);

  return { channels, directMessages, loading, error };
};
